import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class MarketMapPostLoginUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult(req) {
        return await this.repo.getMarketMapPL(req);
    }
}
export default MarketMapPostLoginUseCase;
